{{'PAY_FOR_BOOKING' | translate}}


<button (click)="pay()">{{'PAY_NOW' | translate}}</button>
